import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const SlideshowIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    viewBox="0 0 36 28"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M34.32 0a1.183 1.183 0 0 1 0 2.367h-1.776V20.84c0 .654-.53 1.184-1.183 1.184H18.935v3.61h2.958a1.183 1.183 0 1 1 0 2.366H13.61a1.183 1.183 0 1 1 0-2.367h2.959v-3.61H4.142c-.654 0-1.183-.53-1.183-1.183V2.367H1.183a1.183 1.183 0 0 1 0-2.367zm-4.142 2.367H5.325v17.29h24.853V2.367zM13.78 5.58a1.183 1.183 0 0 1 1.183 0l7.728 4.467a1.183 1.183 0 0 1 0 2.048l-7.728 4.461a1.183 1.183 0 0 1-1.775-1.023V6.609a1.183 1.183 0 0 1 .592-1.03zm1.775 3.077v4.828l4.178-2.414-4.178-2.414z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

SlideshowIcon.propTypes = propTypes;

export default SlideshowIcon;
